import React, { useState } from 'react';
import useCompanyBrand from '../hooks/useCompanyBrand';
import useCurrentUser from '../hooks/useCurrentUser';
import BrandWizard from './BrandWizard';

/**
 * First-login tutorial (item 40): while the company's onboarding flag is
 * unset, the guided brand wizard opens automatically after login. Finishing
 * or skipping persists the flag, so it only ever shows for the company's
 * first user.
 *
 * Admins only: branding is an Owner task and both FINISH and SKIP persist the
 * onboarding flag via the admin-gated brand POST. A non-admin who saw this
 * could neither save nor skip — they'd be trapped and re-prompted every login
 * (Daniel, 2026-06-24). Settings already hides the brand section from
 * non-admins; gate the auto-launch the same way.
 */
const FirstLoginBrandWizard: React.FC = () => {
  const { brand, status } = useCompanyBrand();
  const { isAdmin, isLoading } = useCurrentUser();
  const [dismissed, setDismissed] = useState(false);

  if (
    status !== 'success'
    || !brand
    || brand.onboardingCompleted
    || dismissed
    || isLoading
    || !isAdmin
  ) {
    return null;
  }

  return (
    <BrandWizard
      isOpen
      onboarding
      brand={brand}
      onClose={() => setDismissed(true)}
    />
  );
};

export default FirstLoginBrandWizard;
